import {
  typographyTheme
} from "./chunk-CXJEJBKT.js";
import {
  sliderRangeTheme,
  sliderTheme,
  sliderThumbTheme,
  sliderTickTheme
} from "./chunk-CPR7EA3T.js";
import {
  spinnerTheme
} from "./chunk-CBF6OFZW.js";
import {
  switchTheme
} from "./chunk-7SWBG6UK.js";
import {
  tabsListTheme,
  tabsPanelTheme,
  tabsTheme,
  tabsTriggerIndicatorTheme,
  tabsTriggerTheme
} from "./chunk-FHF6P4UN.js";
import {
  textareaTheme
} from "./chunk-APTGGM6D.js";
import {
  timelineBodyTheme,
  timelineHeaderTheme,
  timelineIconTheme,
  timelineItemTheme,
  timelineSeparatorTheme,
  timelineTheme
} from "./chunk-BAFDZUY3.js";
import {
  tooltipArrowTheme,
  tooltipContentTheme,
  tooltipTheme,
  tooltipTriggerTheme
} from "./chunk-AGIFMRNV.js";
import {
  listItemEndTheme,
  listItemStartTheme,
  listItemTheme,
  listTheme
} from "./chunk-77ZNGTSH.js";
import {
  menuContentTheme,
  menuItemTheme,
  menuTheme,
  menuTriggerTheme
} from "./chunk-5VIFYY3R.js";
import {
  navbarTheme
} from "./chunk-C2SK4YPI.js";
import {
  popoverArrowTheme,
  popoverContentTheme,
  popoverTheme,
  popoverTriggerTheme
} from "./chunk-QTMDCPR3.js";
import {
  progressBarTheme,
  progressTheme
} from "./chunk-U44YIC2J.js";
import {
  radioIndicatorTheme,
  radioItemTheme,
  radioTheme
} from "./chunk-QHXOBAAC.js";
import {
  ratingTheme
} from "./chunk-BGYX7VND.js";
import {
  selectListTheme,
  selectOptionTheme,
  selectTheme,
  selectTriggerTheme
} from "./chunk-BGJMALSI.js";
import {
  checkboxIndicatorTheme,
  checkboxTheme
} from "./chunk-YVCLQOWL.js";
import {
  chipDismissTriggerTheme,
  chipIconTheme,
  chipLabelTheme,
  chipTheme
} from "./chunk-332RUHED.js";
import {
  collapseTheme
} from "./chunk-4JMI2FIT.js";
import {
  dialogContentTheme,
  dialogDismissTriggerTheme,
  dialogOverlayTheme,
  dialogTheme,
  dialogTriggerTheme
} from "./chunk-BQYKGMWX.js";
import {
  drawerDismissTriggerTheme,
  drawerOverlayTheme,
  drawerPanelTheme,
  drawerTriggerTheme
} from "./chunk-ANNCLIQH.js";
import {
  iconButtonTheme
} from "./chunk-LRNZTCBT.js";
import {
  inputIconTheme,
  inputTheme
} from "./chunk-ADIUZG7W.js";
import {
  accordionContentTheme,
  accordionItemTheme,
  accordionTheme,
  accordionTriggerTheme
} from "./chunk-C4GS2FOC.js";
import {
  alertContentTheme,
  alertDismissTriggerTheme,
  alertIconTheme,
  alertTheme
} from "./chunk-YTQ4A2UH.js";
import {
  avatarTheme
} from "./chunk-PTC7KVHU.js";
import {
  badgeContentTheme,
  badgeIndicatorTheme,
  badgeTheme
} from "./chunk-V2YBIGWT.js";
import {
  breadcrumbLinkTheme,
  breadcrumbSeparatorTheme,
  breadcrumbTheme
} from "./chunk-FOAJJTIZ.js";
import {
  buttonGroupTheme
} from "./chunk-LN4CMBOV.js";
import {
  buttonTheme
} from "./chunk-VYISNWQG.js";
import {
  cardBodyTheme,
  cardFooterTheme,
  cardHeaderTheme,
  cardTheme
} from "./chunk-FQY26STY.js";

// src/theme/theme.ts
var theme = {
  accordion: accordionTheme,
  accordionItem: accordionItemTheme,
  accordionTrigger: accordionTriggerTheme,
  accordionContent: accordionContentTheme,
  alert: alertTheme,
  alertContent: alertContentTheme,
  alertIcon: alertIconTheme,
  alertDismissTrigger: alertDismissTriggerTheme,
  avatar: avatarTheme,
  breadcrumb: breadcrumbTheme,
  breadcrumbLink: breadcrumbLinkTheme,
  breadcrumbSeparator: breadcrumbSeparatorTheme,
  button: buttonTheme,
  buttonGroup: buttonGroupTheme,
  checkbox: checkboxTheme,
  checkboxIndicator: checkboxIndicatorTheme,
  card: cardTheme,
  cardHeader: cardHeaderTheme,
  cardBody: cardBodyTheme,
  cardFooter: cardFooterTheme,
  chip: chipTheme,
  chipLabel: chipLabelTheme,
  chipIcon: chipIconTheme,
  chipDismissTrigger: chipDismissTriggerTheme,
  collapse: collapseTheme,
  dialog: dialogTheme,
  dialogTrigger: dialogTriggerTheme,
  dialogOverlay: dialogOverlayTheme,
  dialogContent: dialogContentTheme,
  dialogDismissTrigger: dialogDismissTriggerTheme,
  drawerTrigger: drawerTriggerTheme,
  drawerOverlay: drawerOverlayTheme,
  drawerPanel: drawerPanelTheme,
  drawerDismissTrigger: drawerDismissTriggerTheme,
  iconButton: iconButtonTheme,
  input: inputTheme,
  inputIcon: inputIconTheme,
  list: listTheme,
  listItem: listItemTheme,
  listItemStart: listItemStartTheme,
  listItemEnd: listItemEndTheme,
  menu: menuTheme,
  menuContent: menuContentTheme,
  menuTrigger: menuTriggerTheme,
  menuItem: menuItemTheme,
  popover: popoverTheme,
  popoverTrigger: popoverTriggerTheme,
  popoverContent: popoverContentTheme,
  popoverArrow: popoverArrowTheme,
  progress: progressTheme,
  progressBar: progressBarTheme,
  radio: radioTheme,
  radioItem: radioItemTheme,
  radioIndicator: radioIndicatorTheme,
  rating: ratingTheme,
  select: selectTheme,
  selectTrigger: selectTriggerTheme,
  selectList: selectListTheme,
  selectOption: selectOptionTheme,
  spinner: spinnerTheme,
  switch: switchTheme,
  tabs: tabsTheme,
  tabsList: tabsListTheme,
  tabsTrigger: tabsTriggerTheme,
  tabsPanel: tabsPanelTheme,
  tabsTriggerIndicator: tabsTriggerIndicatorTheme,
  textarea: textareaTheme,
  tooltip: tooltipTheme,
  tooltipTrigger: tooltipTriggerTheme,
  tooltipContent: tooltipContentTheme,
  tooltipArrow: tooltipArrowTheme,
  typography: typographyTheme,
  timeline: timelineTheme,
  timelineItem: timelineItemTheme,
  timelineHeader: timelineHeaderTheme,
  timelineIcon: timelineIconTheme,
  timelineSeparator: timelineSeparatorTheme,
  timelineBody: timelineBodyTheme,
  navbar: navbarTheme,
  badge: badgeTheme,
  badgeContent: badgeContentTheme,
  badgeIndicator: badgeIndicatorTheme,
  slider: sliderTheme,
  sliderRange: sliderRangeTheme,
  sliderThumb: sliderThumbTheme,
  sliderTick: sliderTickTheme
};
var theme_default = theme;

export {
  theme,
  theme_default
};
